<template>
  <div class="modal fade entrance-vars"
       :class="{
        'show d-block': state.showGate
       }">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="entrance d-flex align-items-center justify-content-center">
          <div class="bg-white content position-relative">
            <button
              v-if="state.showRedirectButton"
              type="button"
              class="btn-nulled text-secondary fw-bold position-absolute btn-close-custom"
              @click="onClose"
            >
              CLOSE
            </button>
            <button
              v-else
              type="button"
              class="btn-nulled text-secondary fw-bold position-absolute btn-close-custom"
              @click="closeModal"
            >
              CLOSE
            </button>
            <div class="d-flex justify-content-center logo">
              <img :src="entrance.logo.link" :alt="entrance.logo.alt">
            </div>
            <p class="h3" v-if="!state.showRedirectButton">{{ entrance.header }}</p>
            <p class="h3" v-else>{{ entrance.redirect.title }}</p>
            <div class="d-flex justify-content-center input-search" v-if="!state.showRedirectButton">
              <div class="d-flex flex-column align-items-center">
                <p class="text-center">{{ entrance.input.header }}</p>
                <div class="input-container w-100">
                  <Input
                    :shouldHaveSearch="true"
                    :shouldHaveSearchClear="true"
                    v-model="state.city"
                    @placeChanged="handlePlace"
                    @onClear="handleClear"
                    :autocomplete="true"
                    :placeholder="entrance.input.placeholder"
                    :ref="inputRef"
                    :autocompleteOptions="state.autocompleteOptions"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center input-search" v-if="state.showRedirectButton">
              <div class="d-flex flex-column align-items-center">
                <div v-html="entrance.redirect.content" class="text-center m-0"/>
                <ButtonRed :text="entrance.redirect.btnText" :href="entrance.redirect.link" hyperlink
                           class="redirect-btn"/>
              </div>
            </div>
            <div class="d-flex flex-column align-items-center survey"
                 v-if="state.showSurvey && !state.showRedirectButton">
              <div class="d-md-flex align-items-center">
                <p class="question mb-2 mb-md-0">{{ entrance.survey.question }}</p>
                <div class="d-flex align-items-center">
                  <div v-for="(button, index) in entrance.survey.options" class="question-item d-flex">
                    <input type="radio" :id="index" :checked="index === 0 ? state.radio.products : state.radio.service"
                           @click="handleRadio(index)">
                    <label :for="index" class="mb-0 ms-2">{{ button }}</label>
                  </div>
                  <ButtonRed :text="entrance.survey.button" @click="onSubmit"/>
                </div>
              </div>
            </div>
            <div class="container companies">
              <div class="row companies-list justify-content-center">
                <div v-for="image in entrance.companies"
                     class="col-4 col-md-2 justify-content-center d-flex align-items-center">
                  <img :src="image.link" :alt="image.alt" class="company-logo">
                </div>
              </div>
            </div>
            <div class="footer-header">
              <p class="h4 fw-bold text-center mb-0">{{ entrance.footerHeader }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, watchEffect} from "vue";
import ButtonRed from "@/components/common/ButtonRed";
import Input from "@/components/common/Input";
import useLoadData from "@/composables/useLoadData";
import {autocompleteOptions} from "@/config/config";

const props = defineProps({
  show: Boolean,
  entrance: {
    timeToShow: Number,
    logo: {
      link: String,
      alt: String
    },
    header: String,
    input: {
      header: String,
      placeholder: String
    },
    companies: Array,
    footerHeader: String,
    survey: {
      question: String,
      options: Array,
      button: String
    },
    redirect: {
      title: String,
      link: String,
      btnText: String,
      content: String
    }
  }
})

const state = reactive({
  showGate: false,
  radio: {
    products: true,
    service: false,
  },
  showSurvey: false,
  city: '',
  search: '',
  autocompleteOptions: {
    componentRestrictions: autocompleteOptions.componentRestrictions,
    types: ['address']
  },
  showRedirectButton: false
})

const inputRef = ref(null)

onMounted(() => setTimeout(() => state.showGate = true, props.entrance.timeToShow * 1000))

watchEffect(() => state.showGate && document.querySelector('body').classList.add('entrance-wrapper'))

const handleRadio = (index) => {
  if (index === 0) {
    state.radio = {
      products: true,
      service: false,
    }
  } else {
    state.radio = {
      products: false,
      service: true,
    }
  }
}

const handlePlace = (location) => {
  state.search = location.city
  state.location = location
  state.showSurvey = true
}

const handleClear = () => state.showSurvey = false

const {data: formSubmitResponse, fetchData: sendForm} = useLoadData()

const onSubmit = async () => {
  await sendForm({
    url: '/brand/getclosest',
    params: {
      latitude: state.location.latitude,
      longitude: state.location.longitude,
      city: state.location.city,
      offerSales: state.radio.products
    }
  })
  formSubmitResponse.value?.brandFound ? location.reload() : (state.showRedirectButton = true)
}

const onClose = async () => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);
  document.cookie = `NotShowEntrance=true; expires=${expirationDate.toUTCString()}; path=/;`;
  location.reload();
}

const closeModal = () => {
  state.showGate = false;
  document.querySelector('body').classList.remove('entrance-wrapper');
}
</script>
